import {
    SMS_SUPPLIER_PREFIX_CREATE_METHOD,
    SMS_SUPPLIER_PREFIX_REMOVE_LIST_METHOD,
    SMS_SUPPLIER_PREFIX_MODIFY_LIST_METHOD,
    SMS_SUPPLIER_PREFIX_SET_ACTIVE_METHOD,

    ALLOCATION_TEMPLATE_API,
    SMS_ALLOCATION_TEMPLATE_API,
    TRUNK_NUMBER_CHANGE_RATE_API,
    SMS_TRUNK_NUMBER_CHANGE_RATE_API,
    TRUNK_NUMBER_REVOKE_API,
    SMS_TRUNK_NUMBER_REVOKE_API,
    TRUNK_NUMBER_MOVE_TO_TRUNK_API,
    SMS_TRUNK_NUMBER_MOVE_TO_TRUNK_API,
} from "const/apiMethods";

export const getPermissionFlags = ({ service, checkPermissionsFor, permissions }) => {
    const hasPermission = (method) => {
        return checkPermissionsFor(method, permissions);
    };


    const allocateTrunkMethod = service ? ALLOCATION_TEMPLATE_API : SMS_ALLOCATION_TEMPLATE_API;
    const changeRateNumbersMethod = service ? TRUNK_NUMBER_CHANGE_RATE_API : SMS_TRUNK_NUMBER_CHANGE_RATE_API;
    const revokeNumbersMethod = service ? TRUNK_NUMBER_REVOKE_API : SMS_TRUNK_NUMBER_REVOKE_API;
    const moveToOtherTrunkMethod = service ? TRUNK_NUMBER_MOVE_TO_TRUNK_API : SMS_TRUNK_NUMBER_MOVE_TO_TRUNK_API;

    return {
        showAddPrefixButton: hasPermission(SMS_SUPPLIER_PREFIX_CREATE_METHOD),
        showDeletePrefixesButton: hasPermission(SMS_SUPPLIER_PREFIX_REMOVE_LIST_METHOD),
        showModifyPrefixesButton: hasPermission(SMS_SUPPLIER_PREFIX_MODIFY_LIST_METHOD),
        showActivePrefixesButton: hasPermission(SMS_SUPPLIER_PREFIX_SET_ACTIVE_METHOD),
        showAllocateTrunkButton: hasPermission(allocateTrunkMethod),
        showChangeRateNumbersButton: hasPermission(changeRateNumbersMethod),
        showRevokeNumbersButton: hasPermission(revokeNumbersMethod),
        showMoveToOtherTrunkButton: hasPermission(moveToOtherTrunkMethod),
    };
};
